var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header__notification" },
    [
      _vm.activateUndo
        ? _c(
            "div",
            {
              staticClass: "undo-popup",
              class: _vm.activateUndo ? "fade__in" : "fade__out"
            },
            [
              _c(
                "div",
                [
                  _c(
                    "span",
                    { staticClass: "close", on: { click: _vm.hideUndoPopup } },
                    [_c("i", { staticClass: "fas fa-times" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "undo__text text-primary fw-bold" },
                    [_vm._v(_vm._s(_vm.activateUndoText))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "header-filter-btns float-right",
                      attrs: { variant: "theme" },
                      on: { click: _vm.undo }
                    },
                    [
                      !_vm.isMobile() ? _c("span", [_vm._v("Undo")]) : _vm._e(),
                      _vm._v(" "),
                      _vm.isMobile()
                        ? _c("i", { staticClass: "fas fa-undo" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "sec float-right" }, [
                        _vm._v("10")
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-global-alert-detail",
          attrs: { size: "lg", "hide-footer": "", id: "globalAlertDetail" }
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("\n      " + _vm._s(_vm.alertTitle) + "\n      "),
            _vm.alertTime != ""
              ? _c("p", { staticClass: "notification-sender" }, [
                  _vm._v(
                    "sent by " +
                      _vm._s(_vm.alertSender) +
                      " @ " +
                      _vm._s(
                        _vm._f("moment")(
                          _vm.getLocalAlertTime(_vm.alertTime),
                          "MMM Do, hh:mm a"
                        )
                      )
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.alertDetail) } })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editDeliverableModalAlert",
            title: ""
          },
          on: {
            hide: _vm.editDeliverableModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditModal", {
            ref: "refEditModal",
            attrs: {
              allContacts: _vm.allContacts,
              modalId: "editDeliverableModalAlert",
              namespace: "",
              tabIndex: _vm.tabIndex
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown" }, [
        _c(
          "div",
          {
            staticClass: "icon cursor-pointer dropdown-toggle mr-2",
            attrs: {
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "false"
            },
            on: { click: _vm.updatePerfectScroll }
          },
          [
            _vm.notificationCount
              ? _c("span", { staticClass: "notification-count" })
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              class:
                _vm.notificationCount > 0 &&
                !_vm.$store.state.deliverables.newNotificationPopupClose
                  ? "animated"
                  : "",
              attrs: {
                width: "30px",
                src: require("@/csmworkflow/img/bell-module.svg")
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.notificationCount > 0 &&
        !_vm.$store.state.deliverables.newNotificationPopupClose
          ? _c(
              "span",
              {
                staticClass: "new__notification__popup",
                class: _vm.newNotificationPopup ? "fade__in" : "fade__out"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "dropdown-item notification-title text-primary text-center cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.$router.currentRoute.name != "userGlobalAlert"
                          ? _vm.$router.push({ name: "userGlobalAlert" })
                          : ""
                        _vm.$store.state.deliverables.newNotificationPopupClose = true
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "close",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.handlePopupClose.apply(null, arguments)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-times" })]
                    ),
                    _vm._v(" "),
                    _vm.notificationCount == 1
                      ? _c(
                          "span",
                          {
                            staticStyle: { "font-weight": "normal !important" }
                          },
                          [_vm._v("You have a new notification.")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.notificationCount > 1
                      ? _c(
                          "span",
                          {
                            staticStyle: { "font-weight": "normal !important" }
                          },
                          [
                            _vm._v("You have "),
                            _c("span", { staticClass: "fw-bold" }, [
                              _vm._v(_vm._s(_vm.notificationCount))
                            ]),
                            _vm._v(" new notifications.")
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dropdown-menu",
            class:
              _vm.notificationList.length == 0 ? "no__notification__popup" : ""
          },
          [
            _c(
              "div",
              [
                _c(
                  "div",
                  {
                    staticClass: "dropdown-item notification-title text-primary"
                  },
                  [
                    _vm._v("\n          Notifications\n          "),
                    _c(
                      "span",
                      { staticClass: "float-right view-all" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "dropdown-item",
                            attrs: {
                              href: "#",
                              to: { name: "userGlobalAlert" }
                            }
                          },
                          [_vm._v("View All")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("perfect-scrollbar", { ref: "notification__scroll" }, [
                  _c(
                    "span",
                    _vm._l(_vm.notificationList, function(alert, index) {
                      return _c(
                        "a",
                        {
                          key: "userAlert-" + index,
                          staticClass: "dropdown-item notification-item",
                          class: alert.status == 1 ? "read" : "",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.onNotificationClick(alert)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "notification-icon-wrapper" },
                            [
                              _vm.getDeliverableIdFromAlert(alert)
                                ? _c("img", {
                                    staticClass: "notification-icon",
                                    attrs: {
                                      src: require("@/csmworkflow/img/project-deliverable-white.svg"),
                                      alt: "Deliverable"
                                    }
                                  })
                                : _vm.getProjectIdFromAlert(alert)
                                ? _c("i", {
                                    staticClass:
                                      "fas fa-folder fa-fw notification-icon-fa",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _c("img", {
                                    staticClass: "notification-icon",
                                    attrs: {
                                      src: require("@/csmworkflow/img/bell-regular.svg"),
                                      alt: "Notification"
                                    }
                                  })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isNonGeneralAlert(alert)
                            ? _c(
                                "span",
                                { staticClass: "notification-details" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "notification-title" },
                                    [_vm._v(_vm._s(alert.title))]
                                  ),
                                  _vm._v(" "),
                                  alert.alert_type == "chat" ||
                                  alert.alert_type == "project-chat" ||
                                  alert.alert_type == "deliverable-chat"
                                    ? _c("span", [
                                        _vm._v(
                                          "sent by " +
                                            _vm._s(alert.sender) +
                                            "."
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  alert.task_count > 0 ||
                                  alert.chat_count > 0 ||
                                  alert.update_count > 0
                                    ? _c("br")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  alert.task_count > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "notification-sender" },
                                        [
                                          _vm._v(
                                            "\n                  +" +
                                              _vm._s(alert.task_count) +
                                              " \n                  " +
                                              _vm._s(
                                                _vm.pluralize(
                                                  alert.task_count,
                                                  "task update",
                                                  "task updates"
                                                )
                                              )
                                          ),
                                          _vm.shouldAddComma(
                                            alert,
                                            "task_count"
                                          )
                                            ? [_vm._v(",")]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  alert.chat_count > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "notification-sender" },
                                        [
                                          _vm._v(
                                            "\n                  +" +
                                              _vm._s(alert.chat_count) +
                                              " \n                  " +
                                              _vm._s(
                                                _vm.pluralize(
                                                  alert.chat_count,
                                                  "message",
                                                  "messages"
                                                )
                                              )
                                          ),
                                          _vm.shouldAddComma(
                                            alert,
                                            "chat_count"
                                          )
                                            ? [_vm._v(",")]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  alert.update_count > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "notification-sender" },
                                        [
                                          _vm._v(
                                            "\n                  +" +
                                              _vm._s(alert.update_count) +
                                              " \n                  " +
                                              _vm._s(
                                                _vm.pluralize(
                                                  alert.update_count,
                                                  "update",
                                                  "updates"
                                                )
                                              )
                                          ),
                                          _vm.shouldAddComma(
                                            alert,
                                            "update_count"
                                          )
                                            ? [_vm._v(",")]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "notification-time-row" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "notification-time" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fromNowDate(
                                                _vm.getLocalAlertTime(
                                                  alert.created_at
                                                )
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.shouldShowProjectButton(alert)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "notification-view-link",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.openProjectFromAlert(
                                                    alert
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    View Project\n                  "
                                              )
                                            ]
                                          )
                                        : _vm.shouldShowDeliverableButton(alert)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "notification-view-link",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.openDeliverableFromAlert(
                                                    alert
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    View Deliverable\n                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "span",
                                { staticClass: "notification-details" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "notification-title" },
                                    [_vm._v(_vm._s(alert.title))]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "sent by " + _vm._s(alert.sender) + "."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "notification-time-row" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "notification-time" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.fromNowDate(
                                                _vm.getLocalAlertTime(
                                                  alert.created_at
                                                )
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.notificationList.length == 0
              ? _c("div", [
                  _c(
                    "span",
                    {
                      staticClass:
                        "dropdown-item notification-title text-center"
                    },
                    [_vm._v("You have no unread notifications.")]
                  )
                ])
              : _vm._e()
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }